import { createFileRoute } from '@tanstack/react-router';

import { WhiteLabelsTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();
  return (
    <WhiteLabelsTab advisoryOrganizationId={params.advisoryOrganizationId} />
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/white-labels'
)({
  component: Page
});
